
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#008CE1","fill-rule":"evenodd","d":"M8 2a6 6 0 110 12A6 6 0 018 2zm0 1a5 5 0 100 10A5 5 0 008 3zm.81 3.465L8.8 10.133l.008.09c.046.263.299.422.76.478V11l-3.206.006v-.293l.144-.006a.907.907 0 00.436-.132.442.442 0 00.205-.39V7.685l-.006-.085c-.043-.27-.3-.43-.773-.484l.006-.375 2.438-.275zm-.826-2.262a.833.833 0 01.85.855.819.819 0 01-.243.598.797.797 0 01-.589.246.877.877 0 01-.621-.228.757.757 0 01-.246-.58c0-.262.079-.476.237-.642a.808.808 0 01.612-.249z"}})])
          )
        }
      }
    